import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import Accordion from "../Accordion";
import AccordionItem from "../Accordion/item";
import SubCategories from "../SubCategories";
const MainProductCategories = (prop) => (React.createElement("div", { className: styles.container }, !!prop.categories &&
    prop.categories.map((x) => (React.createElement(Accordion, { key: x.code },
        React.createElement(AccordionItem, { label: x.displayName, tabindex: prop.tabIndex },
            React.createElement(SubCategories, { key: x.code, mainCategory: x, tabIndex: prop.tabIndex })))))));
export default connect((state) => ({
    categories: !!state.mainMenu && state.mainMenu.primaryMenuItems,
}))(MainProductCategories);
